import { Construction, House, SearchX, Wrench } from 'lucide-react';
import type { ReactNode } from 'react';
import { isRouteErrorResponse, Link, useRouteError } from 'react-router';
import { MENSAGEM_EM_DESENVOLVIMENTO } from '@metaepi/shared';
import { EstadoErro, SeloStatus } from '../../components/ui';

function Pagina({ titulo, children }: { titulo: string; children: ReactNode }) {
  return (
    <div className="mx-auto flex max-w-2xl flex-col gap-4">
      <h1 className="text-2xl font-bold text-texto">{titulo}</h1>
      {children}
    </div>
  );
}

const linkInicio = (
  <Link
    to="/"
    className="inline-flex h-11 items-center gap-2 self-start rounded-lg border border-borda bg-superficie px-5 text-sm font-medium text-texto hover:bg-superficie-2"
  >
    <House className="size-4" aria-hidden="true" />
    Voltar ao início
  </Link>
);

/** Funcionalidade planejada para um módulo futuro do plano. */
export function EmConstrucao({
  titulo,
  modulo,
  descricao,
}: {
  titulo: string;
  modulo: number;
  descricao: string;
}) {
  return (
    <Pagina titulo={titulo}>
      <div className="flex items-start gap-4 rounded-xl border border-borda bg-superficie p-6">
        <Construction className="size-8 shrink-0 text-primaria" aria-hidden="true" />
        <div className="flex flex-col gap-2">
          <SeloStatus tipo="info">{`Previsto no Módulo ${modulo}`}</SeloStatus>
          <p className="text-texto">{descricao}</p>
        </div>
      </div>
      {linkInicio}
    </Pagina>
  );
}

/** D-014: agravo visível no sistema, porém bloqueado. */
export function EmDesenvolvimento({ titulo }: { titulo: string }) {
  return (
    <Pagina titulo={titulo}>
      <div className="flex items-start gap-4 rounded-xl border border-desenvolvimento/40 bg-desenvolvimento-fundo p-6">
        <Wrench className="size-8 shrink-0 text-desenvolvimento" aria-hidden="true" />
        <div className="flex flex-col gap-2">
          <SeloStatus tipo="desenvolvimento">Em desenvolvimento</SeloStatus>
          <p className="text-texto">{MENSAGEM_EM_DESENVOLVIMENTO}</p>
        </div>
      </div>
      {linkInicio}
    </Pagina>
  );
}

export function NaoEncontrada() {
  return (
    <Pagina titulo="Página não encontrada">
      <div className="flex items-center gap-3 text-texto-suave">
        <SearchX className="size-6" aria-hidden="true" />
        <p>O endereço acessado não existe ou foi alterado.</p>
      </div>
      {linkInicio}
    </Pagina>
  );
}

/** Erro inesperado na tela. Nunca mostra detalhes técnicos ao usuário. */
export function ErroRota() {
  const erro = useRouteError();
  if (isRouteErrorResponse(erro) && erro.status === 404) return <NaoEncontrada />;
  return (
    <div className="p-6">
      <Pagina titulo="Algo deu errado">
        <EstadoErro
          titulo="Esta tela encontrou um problema."
          descricao="Recarregue a página. Se o problema continuar, avise o suporte."
          aoTentarNovamente={() => window.location.reload()}
        />
        {linkInicio}
      </Pagina>
    </div>
  );
}
